import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const YearlyBonusReportPrint = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [companyInfo] = useState({
    name: "Nissi Infotech",
    subtitle: "Nissi",
    type: "CIVIL CONSTRUCTION",
    address: "3/42-12, Nagappa colony, Kavundampalayam, Coimbatore-30, Tamil Nadu, India",
    phone: "Phone No: 9003744644",
    email: "infraconsoft-implementation@nissiinfotech.com"
  });

  useEffect(() => {
    loadPrintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadPrintData = () => {
    try {
      // ✅ Get data from localStorage instead of API
      const storedData = localStorage.getItem("bonusPrintData");
      
      if (!storedData) {
        alert("No data available for printing. Please search first.");
        window.close();
        return;
      }

      const parsedData = JSON.parse(storedData);
      
      if (!parsedData || parsedData.length === 0) {
        alert("No records found to print");
        window.close();
        return;
      }

      setData(parsedData);
    } catch (err) {
      console.error("Print Data Error:", err);
      alert("Failed to load print data");
      window.close();
    } finally {
      setLoading(false);
    }
  };

  // Auto print when data loads
  useEffect(() => {
    if (!loading && data.length > 0) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [loading, data]);

  const getFinancialYearDisplay = () => {
    const fyr = localStorage.getItem("bonusFyr") || localStorage.getItem("fyr") || "";
    const parts = fyr.split('-');
    if (parts.length === 2) {
      return `${parts[0]} TO${parts[1]}`;
    }
    return fyr;
  };

  const calculateTotal = (field) => {
    return data.reduce((sum, row) => sum + (parseFloat(row[field]) || 0), 0);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto text-blue-600" />
          <p className="mt-4 text-gray-600 font-semibold">Loading print data...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Print Styles */}
      <style>{`
        @media print {
          @page {
            size: A4 landscape;
            margin: 10mm;
          }
          
          body {
            margin: 0;
            padding: 0;
          }
          
          .no-print {
            display: none !important;
          }
          
          .print-container {
            width: 100%;
            font-family: Arial, sans-serif;
          }
          
          table {
            page-break-inside: auto;
          }
          
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
          
          thead {
            display: table-header-group;
          }
          
          tfoot {
            display: table-footer-group;
          }
        }
        
        @media screen {
          .print-container {
            max-width: 1400px;
            margin: 20px auto;
            padding: 20px;
            background: white;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
          }
        }
      `}</style>

      <div className="print-container">
        {/* Header */}
        <div style={{ border: '2px solid #000', padding: '10px', marginBottom: '10px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ width: '150px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <div style={{ 
                    width: '120px', 
                    height: '80px', 
                    border: '2px solid #000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    backgroundColor: '#000',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '10px',
                    flexDirection: 'column'
                  }}>
                    <div>NISSI</div>
                    <div>INFOTECH</div>
                  </div>
                </td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  <h2 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold' }}>
                    {companyInfo.name}
                  </h2>
                  <p style={{ margin: '2px 0', fontSize: '12px' }}>{companyInfo.subtitle}</p>
                  <p style={{ margin: '2px 0', fontSize: '12px', fontWeight: 'bold' }}>
                    {companyInfo.type}
                  </p>
                  <p style={{ margin: '2px 0', fontSize: '10px' }}>{companyInfo.address}</p>
                  <p style={{ margin: '2px 0', fontSize: '10px' }}>
                    {companyInfo.phone} - {companyInfo.email}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Title */}
        <div style={{ 
          border: '2px solid #000', 
          padding: '8px', 
          textAlign: 'center',
          marginBottom: '10px',
          fontWeight: 'bold',
          fontSize: '14px'
        }}>
          BONUS LIST FOR THE YEAR OF {getFinancialYearDisplay()}
        </div>

        {/* Screen Badge */}
        <div style={{ textAlign: 'right', fontSize: '10px', marginBottom: '5px' }}>
          INFRA SCREEN : C-37/1
        </div>

        {/* Data Table */}
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          border: '2px solid #000',
          fontSize: '10px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '30px' }}>
                S.No
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '70px' }}>
                Emp Code
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'left', width: '150px' }}>
                Emp Name
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '120px' }}>
                Designation
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '100px' }}>
                Acc.No
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', width: '80px' }}>
                Bonus Amount
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', width: '80px' }}>
                Batta Amount
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', width: '90px' }}>
                Total Bonus<br/>Amount
              </th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '80px' }}>
                Signature
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'center' }}>
                  {idx + 1}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'center' }}>
                  {row.EmployeeCode || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'left' }}>
                  {row.EmployeeName || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'center' }}>
                  {row.Designation || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'center' }}>
                  {row['A/C No.'] || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                  {parseFloat(row.Total || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                  {parseFloat(row.BattaBonus || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', fontWeight: 'bold' }}>
                  {parseFloat(row.TotalBonus || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'center' }}>
                  {/* Signature column - empty */}
                </td>
              </tr>
            ))}

            {/* Total Row */}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
              <td colSpan={5} style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                Total Amount(Rs)
              </td>
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                {calculateTotal('Total').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                {calculateTotal('BattaBonus').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                {calculateTotal('TotalBonus').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '6px' }}></td>
            </tr>
          </tbody>
        </table>

        {/* Footer */}
        <div style={{ 
          marginTop: '40px', 
          display: 'flex', 
          justifyContent: 'space-between',
          fontSize: '11px',
          fontWeight: 'bold'
        }}>
          <div style={{ textAlign: 'center', width: '33%' }}>
            <div style={{ borderTop: '1px solid #000', paddingTop: '5px', marginTop: '50px' }}>
              Prepared By
            </div>
          </div>
          <div style={{ textAlign: 'center', width: '33%' }}>
            <div style={{ borderTop: '1px solid #000', paddingTop: '5px', marginTop: '50px' }}>
              Checked By
            </div>
          </div>
          <div style={{ textAlign: 'center', width: '33%' }}>
            <div style={{ borderTop: '1px solid #000', paddingTop: '5px', marginTop: '50px' }}>
              Sr.Manager Accounts
            </div>
          </div>
        </div>

        {/* Print Button (Only visible on screen) */}
        <div className="no-print" style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={() => window.print()}
            style={{
              padding: '10px 30px',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              marginRight: '10px'
            }}
          >
            Print Report
          </button>
          <button
            onClick={() => window.close()}
            style={{
              padding: '10px 30px',
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            Close Window
          </button>
        </div>
      </div>
    </>
  );
};

export default YearlyBonusReportPrint;
